import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonToast } from '@ionic/vue';
import { onMounted, onUnmounted, ref } from 'vue';
import { ConnectionStatus, Network } from '@capacitor/network';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'connectivityToast',
  setup(__props) {

const { t } = useI18n({
      inheritLocale: true,
      useScope: 'global'
})

const haveInternet = ref(true);
let intervalID: number;

const checkConnection = () => {
  intervalID = setInterval(() => {
    Network.getStatus().then((network: ConnectionStatus) => {
        haveInternet.value = network.connected;
    });
  }, 3000); 
}


onMounted(() => {
    checkConnection();
})

onUnmounted(() => {
    clearInterval(intervalID);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonToast), {
    "is-open": !haveInternet.value,
    message: _unref(t)('connectivityToast.toastMessage')
  }, null, 8, ["is-open", "message"]))
}
}

})